import { render } from "./WarmUpGoalie.vue?vue&type=template&id=3f0382f8"
import script from "./WarmUpGoalie.vue?vue&type=script&lang=js"
export * from "./WarmUpGoalie.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/1-fbk-tabor/1-fbk-tabor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__